import React from 'react';
import {HeaderAndFooterCard} from "../../components/molecules";

const Services = () => {
    return (
        <div className="container">

            <div className="section-title">
                <h2>Project Repositories</h2>
                <p>The below mentioned repositories are some of my open worked/contributed project samples.</p>
            </div>

            <div className="row">
                {
                    [
                        {
                            repo:'structlooper/GUI_with_Tkinter_mysql',
                        },
                        {
                            repo:'codedwire/React-Start-temp',
                        },
                        {
                            repo:'codedwire/CRUD-LARAVEL',
                        },
                        {
                            repo:'structlooper/Ngo_webSite',
                        },

                        {
                            repo:'structlooper/apiLaravelCRUD',
                        },
                    ].map(repo => HeaderAndFooterCard(repo))
                }

            </div>

        </div>
    )
}
export default Services;